// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    HTML_SITEMAP_INDEX_PAGE_LOADING() {
      return {
        isLoading: true,
        htmlSitemapIndexPage: action.htmlSitemapIndexPage
      };
    },
    HTML_SITEMAP_INDEX_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.htmlSitemapIndexPage
      };
    },
    HTML_SITEMAP_INDEX_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapIndexPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
